import { reduce } from './';
var heading = function heading(node, schema) {
  var result = [];
  node.forEach(function (n) {
    result.push(reduce(n, schema));
  });
  return result.join('');
};
export default heading;